/**
 * OrderProductsSection Component
 *
 * Products section wrapper around OrderItemsTable.
 */

import { OrderItemsTable, type OrderLineItem } from '../OrderItemsTable';

interface OrderProductsSectionProps {
  items: OrderLineItem[];
  supplierId: string | null;
  readOnly: boolean;
  onChange: (items: OrderLineItem[]) => void;
}

export function OrderProductsSection({
  items,
  supplierId,
  readOnly,
  onChange,
}: OrderProductsSectionProps) {
  return (
    <div className="flex flex-col flex-1 min-h-0 bg-neutral-50 rounded-lg border border-neutral-200 p-6">
      <h3 className="text-lg font-semibold text-dark-500 mb-4 shrink-0">Produits</h3>
      <div className="flex-1 overflow-y-auto">
        <OrderItemsTable
          items={items}
          onChange={onChange}
          supplierId={supplierId}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
}
